module.exports = "<!-- <div class=\"sidebar-minimizer\" ></div> -->\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module id = ../../../../../src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module chunks = main